var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 21",
    style: {
      enableBackground: "new 0 0 21 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.5,1.5c-4.97,0-9,4.03-9,9c0,4.97,4.03,9,9,9c4.97,0,9-4.03,9-9C19.5,5.53,15.47,1.5,10.5,1.5z M0,10.5 C0,4.7,4.7,0,10.5,0C16.3,0,21,4.7,21,10.5C21,16.3,16.3,21,10.5,21C4.7,21,0,16.3,0,10.5z M8.25,6C8.66,6,9,6.34,9,6.75V7.5 c0,0.41-0.34,0.75-0.75,0.75C7.84,8.25,7.5,7.91,7.5,7.5V6.75C7.5,6.34,7.84,6,8.25,6z M12.75,6c0.41,0,0.75,0.34,0.75,0.75V7.5 c0,0.41-0.34,0.75-0.75,0.75S12,7.91,12,7.5V6.75C12,6.34,12.34,6,12.75,6z M13.84,12.08c0.37,0.19,0.52,0.64,0.34,1.01 c-0.05,0.1-0.12,0.19-0.16,0.24c-0.06,0.07-0.13,0.15-0.22,0.24c-0.17,0.18-0.41,0.39-0.72,0.6C12.47,14.59,11.59,15,10.5,15h0 c-0.2,0-2.25,0-3.6-1.8c-0.25-0.33-0.18-0.8,0.15-1.05c0.33-0.25,0.8-0.18,1.05,0.15c0.9,1.19,2.28,1.2,2.4,1.2 c0.71,0,1.29-0.26,1.72-0.56c0.21-0.15,0.38-0.3,0.5-0.42c0.06-0.06,0.1-0.11,0.12-0.14c0.01-0.01,0.01-0.01,0.01-0.02 C13.05,12.03,13.48,11.9,13.84,12.08z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirect);
export default __webpack_public_path__ + "static/media/direct.66ec5d22aa7a47a465254cca69c4e90d.svg";
export { ForwardRef as ReactComponent };